import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { StickyScrollUp } from 'react-stickup';
import InputMask from 'react-input-mask';
import { useDownloadApp } from '../utils/download';
import useMediaQuery from '../hooks/useMediaQuery';

const Header = () => {
  const isMobile = useMediaQuery('(max-width: 1200px)');

  const {
    popupApp,
    popupAppClick,
    phoneNumber,
    onChangePhoneNumber,
    isSubmitting,
    phoneNumberSuccess,
    phoneNumberError,
    popupAppSubmit,
  } = useDownloadApp();

  const [mobileMenu, setMobileMenu] = useState(false);

  const mobileMenuClick = useCallback((e) => {
    if ((e.type === 'keydown' && e.key === 'Enter') || e.type === 'click') {
      setMobileMenu((state) => !state);
    }
  }, []);

  return (
    <>
      <div className="topbar">
        <p>
          India’s 1st mobile app for construction.&nbsp;
          <Link to="/about/">
            Learn more
            <img src="/img/small-arrow.svg" alt="" />
          </Link>
        </p>
      </div>
      <div className="header-compensator" />
      <StickyScrollUp disabled={isMobile} className="zindex">
        <div className="header-main">
          <div className="flex-row justify-content-between align-items-center">
            <div className="header-logo">
              <Link to="/" className="logo-header">
                <img
                  src="/img/powerplay-logo.svg"
                  alt="Powerplay logo"
                  width="130px"
                />
              </Link>
              <Link className="hiring-button" to="/career/">
                We’re hiring!
              </Link>
            </div>
            <div className={mobileMenu ? 'menu-main menu-open' : 'menu-main'}>
              <span
                className="hamburger"
                role="button"
                tabIndex="0"
                onClick={mobileMenuClick}
                onKeyDown={mobileMenuClick}>
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 41 32"
                  style={{ enableBackground: 'new 0 0 41 32' }}>
                  <line
                    className="hamburger-line"
                    x1="1"
                    y1="1.5"
                    x2="40"
                    y2="1.5"
                  />
                  <line
                    className="hamburger-line"
                    x1="1"
                    y1="16"
                    x2="40"
                    y2="16"
                  />
                  <line
                    className="hamburger-line"
                    x1="1"
                    y1="30.5"
                    x2="40"
                    y2="30.5"
                  />
                </svg>
              </span>

              <div className="main-nav">
                <Link to="/about/">About</Link>
                <Link to="/product/">Product</Link>
                <Link to="/career/">Career</Link>
                <Link to="/blog/">Blog</Link>
                <a
                  className="solid-nav-button"
                  href="https://portal.getpowerplay.in/login"
                  target="_blank"
                  rel="noopener noreferrer">
                  Login
                </a>
                <button
                  type="button"
                  onClick={popupAppClick}
                  className="mob-button-nav">
                  Download App
                </button>
              </div>
            </div>
          </div>
        </div>
      </StickyScrollUp>

      <div className={`download-app-popup${popupApp ? ' show' : ''}`}>
        <div className="popup-block">
          <button type="button" className="close-pop" onClick={popupAppClick}>
            <svg
              width="16px"
              x="0px"
              y="0px"
              viewBox="0 0 13.7 13.7"
              style={{ enableBackground: 'new 0 0 13.7 13.7' }}>
              <path
                d="M13.6,12.1c0.1,0.1,0.1,0.4,0,0.5l-1,1c-0.1,0.1-0.3,0.1-0.5,0l-0.9-0.9L6.8,8.3l-5.3,5.3c-0.1,0.1-0.4,0.1-0.5,0l-1-1
                  c-0.1-0.1-0.1-0.3,0-0.5l5.3-5.3L0.1,1.6C0,1.4,0,1.2,0.1,1.1l1-1C1.2,0,1.4,0,1.6,0.1l5.3,5.3l5.3-5.3c0.1-0.1,0.3-0.1,0.5,0l1,1
                  c0.1,0.1,0.1,0.3,0,0.5l-0.9,0.9L8.3,6.8L13.6,12.1z"
              />
            </svg>
          </button>
          <h2 className="heading">
            Download Powerplay App for free, to manage your construction
          </h2>

          <form onSubmit={popupAppSubmit}>
            <p>Enter your phone number to get the link via SMS</p>

            <div className="get-sms-link-container">
              <div className="get-sms-link">
                <InputMask
                  mask="+91 *** *** ****"
                  formatChars={{
                    '*': '[0-9]',
                  }}
                  permanents={[0, 1, 2, 3]}
                  maskChar={null}
                  onChange={onChangePhoneNumber}
                  value={phoneNumber}>
                  {(props) => (
                    <input
                      {...props}
                      type="text"
                      placeholder="Your phone number"
                      required
                    />
                  )}
                </InputMask>
                <button
                  type="submit"
                  className="button"
                  disabled={isSubmitting}>
                  <svg
                    width="10px"
                    x="0px"
                    y="0px"
                    viewBox="0 0 19.5 32.7"
                    style={{ enableBackground: 'new 0 0 19.5 32.7' }}>
                    <g>
                      <path
                        d="M4.1,32.3c-0.5,0.5-1.3,0.5-1.7,0l-2-2c-0.5-0.5-0.5-1.3,0-1.7l12.1-12.2L0.4,4.1c-0.5-0.5-0.5-1.3,0-1.7l2-2
		                    c0.5-0.5,1.3-0.5,1.7,0l15,15.1c0.5,0.5,0.5,1.3,0,1.7L4.1,32.3z"
                      />
                    </g>
                  </svg>
                </button>
              </div>
              {phoneNumberSuccess && (
                <small className="success-message">{phoneNumberSuccess}</small>
              )}

              {phoneNumberError && (
                <small className="error-message">{phoneNumberError}</small>
              )}
            </div>
          </form>
          <div className="download-store">
            <p>or Download the app</p>

            <a
              href="https://play.google.com/store/apps/details?id=in.powerplay.android.fieldapp&hl=en_IN"
              target="_blank"
              rel="noopener noreferrer">
              <img src="/img/play-store.svg" alt="playstore" />
            </a>
            <a
              href="https://apps.apple.com/app/id1552606148"
              target="_blank"
              rel="noopener noreferrer">
              <img src="/img/app-store.svg" alt="appstore" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
